module.exports = {
    // committee_id: 512,
    source: 2,
    key: 'Medcon20201010@)@)@!)',
    forum_id:1662,   // 论坛路由中用到的父id
}